import { useCallback, useEffect, useRef } from 'react';
import { Sentry, setSentryUser } from '../lib/sentry';

export function useMonitoring(channelId?: string, displayName?: string) {
  const initialized = useRef(false);

  useEffect(() => {
    if (!channelId || initialized.current) return;
    setSentryUser(channelId, displayName);
    initialized.current = true;
  }, [channelId, displayName]);

  const captureException = useCallback((error: unknown, context?: Record<string, unknown>) => {
    if (context) {
      Sentry.withScope((scope) => {
        scope.setExtras(context);
        Sentry.captureException(error);
      });
    } else {
      Sentry.captureException(error);
    }
  }, []);

  return { captureException };
}
